import 'whatwg-fetch';

/**
 * 导出接口
 */
export const exportCust = async (arg: {
  product: Product;
  params: ConfigParams;
  customLang: FileOrNull;
  customInput: FileOrNull;
  bgImg: FileOrNull;
  localImg: FileOrNull;
  thirdApp: File[];
}): Promise<Blob> => {
  const fd = new FormData();
  fd.append('product', arg.product);
  fd.append('params', JSON.stringify(arg.params));
  arg.customLang && fd.append('lang', arg.customLang);
  arg.customInput && fd.append('inputs', arg.customInput);
  arg.localImg && fd.append('screensaver', arg.localImg);
  arg.bgImg && fd.append('bg', arg.bgImg);
  (arg.thirdApp || []).forEach((app) => {
    fd.append('thirdapp', app);
  });

  const res = await fetch('/GUI/api/export-cust', {
    method: 'POST',
    body: fd,
  });

  if (res.status >= 400) {
    throw new Error('export failed');
  }

  return res.blob();
};

/**
 * 导入接口
 */
export const importCust = async (arg: {
  product: Product;
  custfile: File;
}): Promise<{
  dir: string;
  params: ConfigParams;
  icons: Record<string, string>;
}> => {
  const fd = new FormData();
  fd.append('product', arg.product);
  fd.append('custfile', arg.custfile);

  const res = await fetch('/GUI/api/import-cust', {
    method: 'POST',
    body: fd,
  });

  return res.json();
};

/**
 * 分析apk
 */
export const apkAnalysis = async (
  file: File,
): Promise<{
  className: string;
  inputMethodName?: string;
  packageName: string;
  displayName: string;
  icon: string;
  // 用于"Device Owner Class" 下拉框展示该apk下的所有class
  classNames: string[];
}> => {
  const fd = new FormData();
  fd.append('apk', file);
  const res = await fetch('/GUI/api/apk-analysis', {
    method: 'POST',
    body: fd,
  });
  return res.json();
};

/**
 * 下载文件并缓存
 */
export const getFile = async (uri: string, filename: string): Promise<File> => {
  const res = await fetch('/GUI' + uri, { method: 'GET' });
  const blob = await res.blob();
  const type = res.headers.get('content-type') || undefined;

  return new File([blob], filename, { type });
};

/**
 * 删除上传cust文件生成的临时文件
 */
export const deleteCustTmp = async (dir: string) => {
  const res = await fetch('/GUI/api/import-cust', {
    method: 'DELETE',
    body: JSON.stringify({ dir }),
    headers: {
      'content-type': 'application/json',
    },
  });
  return res.json();
};

/**
 * 向gdms上传cust文件
 */
export const saveCustToGdms = async (
  callback: string,
  token: string,
  file: File,
) => {
  const fd = new FormData();
  fd.append('file', file);
  fd.append('resourceName', file.name);
  fd.append('resourceType', '6');
  const res = await fetch(callback, {
    method: 'POST',
    headers: {
      Authorization: token,
    },
    body: fd,
  });

  return res.json();
};
